import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import {  transactionService } from '../../_services'

class OrdersPage extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            orderList : [] ,
            orderList_pages : 0 , 
            orderList_loading : true ,
        }

        this.onFetchOrderListData = this.onFetchOrderListData.bind(this);
    }

    onFetchOrderListData(state , instance){
        const {  authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberOrdersList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    orderList : response.list , 
                    orderList_pages : response.pages , 
                    orderList_loading : false
                })
            }
        })
    }
    


    render (){
        const { wallet } = this.props;
        
        const { orderList , orderList_loading , orderList_pages   } = this.state;

        const orderList_columns = [
            {
                Header: 'Order Date',
                accessor: 'createdstr'  
            }, 
            {
                Header: 'Type',
                accessor: 'ordertype', 
                Cell: row => (
                    <span className={`is-color-${row.value}`}>
                       {row.value}
                    </span>
                )  
            },
            {
                Header: 'Coin',
                accessor: 'buyCurrency'  
            }, 
            {
                Header: 'Amount',
                accessor: 'amount'  
            },  
            {
                Header: 'Selling Price',
                accessor: 'rate' , 
                Cell: c => (
                    <span>{`${c.original.sellCurrency} ${c.original.rate}`}</span>
                )
            },
            {
                Header: 'Status',
                accessor: 'status'  , 
                Cell: row => (
                    <span className={`tag is-${row.value}`}>
                       {row.value}
                    </span>
                )  
            }, 
        ]

        return (
            <section className="section m-t-xs m-b-lg">
                <div className="container">
                    <div className="columns p-l-lg">
                        
                        <div className="column is-four-sixths is-offset-one-sixth">
                            <h4>Orders Book</h4>
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={orderList}
                                    pages={orderList_pages}
                                    loading={orderList_loading}
                                    columns={orderList_columns}
                                    defaultPageSize = {5} 
                                    onFetchData = {this.onFetchOrderListData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    return {
       authentication
    };
}

const connected = connect(mapStateToProps)(OrdersPage);
export { connected as OrdersPage }; 



// WEBPACK FOOTER //
// ./src/Views/OrdersPage/OrdersPage.jsx